export const DISCUSSION_QUERY_KEY = 'discussion'
export const DISCUSSION_QUERY_VALUE = '1'

export const COMMENT_TAB_QUERY_KEY = 'commentTab'
export const PARENT_COMMENT_ID_QUERY_KEY = 'parentCommentId'
export const COMMENT_ID_QUERY_KEY = 'commentId'

export const SCROLL_QUERY_KEY = 'scroll'
export const SCROLL_QUERY_VALUE = 'comments'

export const NOTIF_SCROLL_SEQ_QUERY_KEY = 'notifScroll'
